const i = () => {
    var t;
    return typeof window == "undefined" || !document.cookie ? null : ((t = (document.cookie.split("; ") || []).find(n => n.startsWith("TestAB_Groups") || n.startsWith("exp-feature-toggle"))) != null ? t : "").split("=")[1] || "";
  },
  s = t => {
    const n = i();
    return !!(n != null && n.includes(t));
  },
  r = t => {
    var n;
    const l = i(),
      o = l == null ? void 0 : l.split(".").map(e => ({
        testName: e.split("_")[0],
        variantName: e.split("_")[1]
      })).find(e => e.testName === t);
    return (n = o == null ? void 0 : o.variantName) != null ? n : null;
  },
  a = t => !t || t === "control";
export { s as getABTest, r as getABTestVariant, a as isOnControlVariant };